var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image",class:_vm.customClasses,style:(_vm.customStyle)},[(!_vm.hasBackground)?_c('img',{attrs:{"src":_vm.src,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }